import { connect } from 'react-redux';
import UserDashboardRoutes from './userDashboardRoutes';

function mapStateToProps({ credentials, user }) {
  const { partnerAccessKey, userIdentityToken } = credentials;
  const { uuid } = user;

  return {
    partnerAccessKey,
    userIdentityToken,
    uuid,
  };
}

export default connect(mapStateToProps, {})(UserDashboardRoutes);
